import React from 'react';
import { motion } from 'framer-motion';
import { PROGRESS } from '../../config/designTokens';
export interface StatTileProps {
  icon: React.ElementType;
  iconColorClass?: string;
  label: string;
  value: React.ReactNode;
  progress?: number;
  progressColorClass?: string;
  interactive?: boolean;
  onClick?: () => void;
  className?: string;
}
export function StatTile({
  icon: Icon,
  iconColorClass = 'text-slate-400',
  label,
  value,
  progress,
  progressColorClass = PROGRESS.barColor,
  interactive = false,
  onClick,
  className = ''
}: StatTileProps) {
  const content = <>
      <div className="flex items-center gap-1.5 sm:gap-2" data-id="element-2540">
        <Icon className={`w-4 h-4 sm:w-5 sm:h-5 ${iconColorClass}`} data-id="element-2541" />
        <span className="text-xs sm:text-sm font-bold text-slate-700 truncate" data-id="element-2542">
          {value} {label}
        </span>
      </div>
      {progress !== undefined && <div className={`h-1.5 w-full ${PROGRESS.trackColor} rounded-full overflow-hidden`} data-id="element-2543">
          <motion.div initial={{
        width: 0
      }} animate={{
        width: `${Math.min(100, Math.max(0, progress))}%`
      }} transition={{
        duration: 0.8,
        ease: 'easeOut',
        delay: 0.2
      }} className={`h-full rounded-full ${progressColorClass}`} data-id="element-2544" />
        </div>}
    </>;
  const baseClasses = `flex-1 flex flex-col gap-1.5 p-2 rounded-xl text-left ${className}`;
  if (interactive) {
    return <motion.button onClick={onClick} className={`${baseClasses} hover:bg-slate-50 transition-colors group focus:outline-none focus:ring-2 focus:ring-orange-300`} data-id="element-2545">
        {content}
      </motion.button>;
  }
  return <div className={baseClasses} data-id="element-2546">{content}</div>;
}